/**
 * Internal dependencies
 */

import { CURRENT_USER_RECEIVE } from "state/action-types";

export default (user) => {
  return {
    type: CURRENT_USER_RECEIVE,
    user,
  };
};
